import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { TimetablesResponse } from '../models/timetables.model';

@Injectable({
  providedIn: 'root',
})
export class TimetablesService extends BaseApiService {
  getTimetables(
    scheduledStartDate: string,
    params?: { headcode?: string; trainUniqueId?: string },
  ): Observable<TimetablesResponse> {
    return this.get<TimetablesResponse>(`/timetables/${scheduledStartDate}`, params);
  }
}
